import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import type { ConversationDigestApiModel as ConversationSummary } from "@noa/api-core";
import { Empty } from "~/components/ui";
import { ConversationHistoryItem } from "./conversation-history-item";

interface ConversationHistoryListContentProps {
  conversations: ConversationSummary[];
  deleted?: boolean;
  search?: string;
}

export const ConversationHistoryListContent: FunctionComponent<ConversationHistoryListContentProps> = ({
  conversations,
  deleted = false,
  search,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col overflow-auto p-4">
      {conversations.length === 0 ? (
        <Empty description={t("common:noDataFound")} />
      ) : (
        conversations.map((conversationSummary) => (
          <ConversationHistoryItem
            key={conversationSummary.session_id}
            conversationSummary={conversationSummary}
            deleted={deleted}
            search={search}
          />
        ))
      )}
    </div>
  );
};
